import { render, staticRenderFns } from "./exhibitionArea.vue?vue&type=template&id=2d110133"
import script from "./exhibitionArea.vue?vue&type=script&lang=js"
export * from "./exhibitionArea.vue?vue&type=script&lang=js"
import style0 from "./exhibitionArea.vue?vue&type=style&index=0&id=2d110133&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports